import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ApiConfiguration } from 'src/api/api-configuration';
import { HomePageListResponseDataItem } from 'src/api/models';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  showLoader = true;
  manufacturerLogo = '';
  baseUrl: string;
  getProductIdAndArticle(id, article) {
    return encodeURIComponent(id + '+' + article);
  }
  indexData: HomePageListResponseDataItem;
  constructor(public apiConfig: ApiConfiguration) {
    this.baseUrl = apiConfig.rootUrl.replace('/api', '');
  }
  setSEO(meta: Meta, keywords: string, description: string) {
    meta.removeTag('name= "robots"');
    if (keywords) {
      meta.updateTag({ name: 'keywords', content: keywords });
    } else {
      meta.removeTag('name= "keywords"');
    }
    if (description) {
      meta.updateTag({ name: 'description', content: description });
    } else {
      meta.removeTag('name= "description"');
    }
    return meta;
  }

}
